module.exports = __webpack_public_path__ + "static/media/nr.2ef5b7c8.svg";